/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-23T10:16:15-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T14:57:01-07:00
*/

import { StyleSheet } from 'aphrodite/no-important';
import { color, borders, spacing } from '../../../../style'

const style = StyleSheet.create({
  composer : {
    // borderTop: borders.DEFAULT,
    display: 'flex',
    padding: '12px',
    backgroundColor: color.GREY_1,
    borderTop: borders.DEFAULT
  },

  container: {
    flex: '1'
  },

  sendContainer: {
    ...spacing.MARGIN_LEFT_SM
  },

  textarea: {
    resize: 'none',
    width: '100%',
    boxSizing: 'border-box',
    border: borders.DEFAULT,
  },

  composerReplacement: {
    display: 'block',
    backgroundColor: '#fff',
    ...spacing.PADDING_MD,
    textAlign: 'center',
  }
});

export default style;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgComposer/style.js